/**
 * Stable chain logos for networks we support in the app.
 * PulseChain uses `public/pulse.png` so it always works if the file is present.
 * Other chains use Trust Wallet asset URLs (reliable PNGs).
 */
const TRUST = 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains';

const CHAIN_ICON_SRC: Record<number, string> = {
  1: `${TRUST}/ethereum/info/logo.png`,
  10: `${TRUST}/optimism/info/logo.png`,
  56: `${TRUST}/smartchain/info/logo.png`,
  100: `${TRUST}/xdai/info/logo.png`,
  130: 'https://icons.llamao.fi/icons/chains/rsz_unichain.jpg',
  137: `${TRUST}/polygon/info/logo.png`,
  143: 'https://icons.llamao.fi/icons/chains/rsz_monad.jpg',
  1514: 'https://icons.llamao.fi/icons/chains/rsz_story.jpg',
  2741: 'https://icons.llamao.fi/icons/chains/rsz_abstract.jpg',
  5000: 'https://icons.llamao.fi/icons/chains/rsz_mantle.jpg',
  42161: `${TRUST}/arbitrum/info/logo.png`,
  43114: `${TRUST}/avalanchec/info/logo.png`,
  534352: 'https://icons.llamao.fi/icons/chains/rsz_scroll.jpg',
  59144: `${TRUST}/linea/info/logo.png`,
  8453: `${TRUST}/base/info/logo.png`,
  11155111: `${TRUST}/ethereum/info/logo.png`,
};

function publicAsset(filename: string): string {
  const base = process.env.PUBLIC_URL ?? '';
  return `${base}/${filename}`.replace(/\/+/g, '/');
}

/** Icon URL for the factory banner and similar UI. */
export function getChainIconSrc(chainId: number): string {
  if (chainId === 369) {
    return publicAsset('pulse.png');
  }
  const known = CHAIN_ICON_SRC[chainId];
  if (known) return known;
  return `https://icons.llamao.fi/icons/chains/${chainId}?w=48&h=48`;
}
